import React, { useState } from 'react';
import {
  IconButton,
  Popover,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import styles from './PaymentHistory.module.css';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import paymentQueries from '../../../../../api/queries/PaymentQueries';
import { useTranslation } from 'react-i18next';

const PaymentHistory = ({ paymentData }) => {
  const shopId = useSelector((state) => state.nonPersistedReducers?.shopSliceReducer?.shopId);
  const { t } = useTranslation();
  const formatCreatedAt = (createdAt) => {
    if (Array.isArray(createdAt)) {
      return createdAt.slice(0, 3).join('. ');
    }

    if (!createdAt) {
      return '-';
    }

    const parsedDate = dayjs(createdAt);
    return parsedDate.isValid() ? parsedDate.format('YYYY. MM. DD') : '-';
  };

  const { data: history } = useQuery({
    queryKey: ['paymentHistory', shopId],
    queryFn: () => paymentQueries.getPaymentsByShopId({ shopId: shopId }),
    refetchOnWindowFocus: false,
    enabled: shopId !== -1
  });

  const [anchorElement, setAnchorElement] = useState(null);

  const handleClick = (event) => {
    setAnchorElement(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElement(null);
  };

  return (
    <div>
      <IconButton onClick={handleClick} sx={{ color: 'black' }}>
        <HistoryIcon />
      </IconButton>

      <Popover
        open={anchorElement !== null && Boolean(anchorElement)}
        anchorEl={anchorElement}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}>
        <Paper sx={{ p: 2 }} className={styles.popover}>
          <Typography variant='subtitle1' sx={{ fontWeight: 'bold' }}>
            {t('subscription.paymentHistory.title')}
          </Typography>
          <TableContainer>
            <Table size='small'>
              <TableHead>
                <TableRow>
                  <TableCell>{t('subscription.paymentHistory.date')}</TableCell>
                  <TableCell>{t('subscription.paymentHistory.amount')}</TableCell>
                  <TableCell>{t('subscription.paymentHistory.status')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {history?.data
                  ?.filter((el) => el?.paymentType === 'RECURRING_PAY')
                  ?.map((el, index) => (
                    <TableRow key={index}>
                      <TableCell>{formatCreatedAt(el?.createdAt)}</TableCell>
                      <TableCell>
                        {el?.totalAmount?.grossAmount} {t('common.currency.symbol')}
                      </TableCell>
                      <TableCell>
                        {el?.status === 'PAID'
                          ? t('subscription.paymentHistory.paid')
                          : t('subscription.paymentHistory.pending')}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Popover>
    </div>
  );
};

export default PaymentHistory;
